module.exports = __webpack_public_path__ + "img/driveSafe-drivingSpeed.c626473.svg";